export * from './AnalyticsService';
import { AnalyticsService } from './AnalyticsService';
export const analyticsService = new AnalyticsService();
export default analyticsService;
